import { render, staticRenderFns } from "./ShopChooseUsers.vue?vue&type=template&id=0885e72d&scoped=true"
import script from "./ShopChooseUsers.vue?vue&type=script&lang=ts"
export * from "./ShopChooseUsers.vue?vue&type=script&lang=ts"
import style0 from "./ShopChooseUsers.vue?vue&type=style&index=0&id=0885e72d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0885e72d",
  null
  
)

export default component.exports